import React from 'react'
import "./workCard.css"


function WorkCard(props) {
    return (
        <div className='project-card'>
        <img src={props.imgsrc} alt='work' />
        <h2 className='project-title'>{props.title}</h2>
        <div className='project-detail'>
            <p>{props.text}</p>
            <div className='project-btns'>
                <a href={props.view} target="_blank" rel="noopener noreferrer" className="btn">View</a>
                <a href={props.source} target="_blank" rel="noopener noreferrer" className="btn">Source</a>
            </div>
        </div>
    </div>
    )
}

export default WorkCard